const defaultState = {
    data: {
        status: null,
        total_items: 0
    },
    filters: {
        page: 1,
        sizePerPage: 10,
        sortName: 'date',
        sortOrder: 'asc'
    },
};

const ifta = (state = defaultState, action) => {
    switch (action.type) {
        case 'GET_IFTA_REPORT_SUCCESS': {
            return {
                ...state,
                data: {
                    ...state.data,
                    ...action.payload.data
                }
            }
        }
        case 'SET_PAGINATION_FILTERS': {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload.filters
                }
            }
        }
        case 'SET_REPORT_STATUS': {
            return {
                ...state,
                data: {
                    ...state.data,
                    status: action.payload.status
                }
            }
        }
        default:
            return state
    }
};

export default ifta;
